/**
 * Created by mac on 2017/5/25.
 */
import Vue from 'vue'
import Vuex from 'vuex'
import app from './modules/app'
import user from './modules/user'
import tmp from './modules/tmp'
import permission from './modules/permission'
import ter from './modules/ter'
import getters from './getters'


Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    app,
    user,
    tmp,
    permission,
    ter
  },
  getters
})

export default store



// WEBPACK FOOTER //
// ./src/vuex/index.js